module.exports = __webpack_public_path__ + "assets/media/6.ac5c4080.wav";